export class ValidationConfigurator {
    
    static disableErrorMessages() {
        const options = ValidationConfigurator.getDefaultValidationOptions();
        options.insertMessages = false;
        ValidationConfigurator.init(options);
    }

    static enableErrorMessages() {
        ValidationConfigurator.init();
    }

    static init(options = ValidationConfigurator.getDefaultValidationOptions()) {
        ko.validation.init(options, true);
    }

    static getDefaultValidationOptions() {
        return {
            registerExtenders: true,
            messagesOnModified: true,
            insertMessages: true,
            parseInputAttributes: true,
            messageTemplate: null,
            decorateElementOnModified: true,
            decorateInputElement: true,
            errorElementClass: "has-error",
            errorMessageClass: "field-validation-error"
        } as KnockoutValidationConfiguration;
    }
}